"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getWeSdkVersion;

function getWeSdkVersion() {
  return "1.16.44"; // Replaced at build-time using babel search-and-replace plugin
}